import { combineReducers, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { normalize, schema } from 'normalizr';
import { CustomerGroupDto } from '../../../common/PricePrgClient';
import { createAsyncAction } from '../../../utils';

const namespaces = {
    customerGroups: 'customerGroups',
    selectedCustomerGroup: 'selectedCustomerGroup'
};

const customerGroupEntity = new schema.Entity<CustomerGroupDto>('customerGroups', undefined, {
    idAttribute: 'customerGroupId'
});

export const fetchCustomerGroups = createAsyncAction<void, CustomerGroupDto[]>(
    namespaces.customerGroups,
    'fetchCustomerGroups'
);

const customerGroupSlice = createSlice({
    name: namespaces.customerGroups,
    initialState: {} as { [customerGroupId: string]: CustomerGroupDto },
    reducers: {},
    extraReducers: builder =>
        builder.addCase(fetchCustomerGroups.success, (state, action) => {
            const normalized = normalize(action.payload, [customerGroupEntity]);
            return normalized.entities.customerGroups ?? {};
        })
});

const selectedCustomerGroupSlice = createSlice({
    name: namespaces.selectedCustomerGroup,
    initialState: null as number | null,
    reducers: {
        setSelectedCustomerGroup: (state, action: PayloadAction<number | null>) => action.payload
    }
});

export const { setSelectedCustomerGroup } = selectedCustomerGroupSlice.actions;

export default combineReducers({
    customerGroups: customerGroupSlice.reducer,
    selectedCustomerGroup: selectedCustomerGroupSlice.reducer
});
